import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { PING_INTERVAL_IN_SECONDS } from '~/constants';

type Actions = {
  setIsBackendOnline: (state: boolean) => void;
  setWasBackendPreviouslyOnline: (state: boolean) => void;
  setSecondsUntilNextPing: (seconds: number) => void;
  setNetworkLostText: (text: string) => void;
};

type InitialState = {
  isBackendOnline: boolean;
  wasBackendPreviouslyOnline: boolean;
  secondsUntilNextPing: number;
  networkLostText: string;
};

const initialState: InitialState = {
  isBackendOnline: true,
  wasBackendPreviouslyOnline: true,
  secondsUntilNextPing: PING_INTERVAL_IN_SECONDS,
  networkLostText: ''
};

export const useNetworkStatusStore = create<InitialState & Actions>()(
  devtools((set) => ({
    ...initialState,
    setIsBackendOnline: (state) => {
      set({
        isBackendOnline: state
      });
    },
    setWasBackendPreviouslyOnline: (state) => {
      set({
        wasBackendPreviouslyOnline: state
      });
    },
    setSecondsUntilNextPing: (seconds) => {
      set({
        secondsUntilNextPing: seconds
      });
    },
    setNetworkLostText: (text) => {
      set({
        networkLostText: text
      });
    }
  }))
);
